<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_ANNOTATION'
        )
      }"
    >
      <textarea
        v-on:keyup="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_ANNOTATION')
        "
        class="i-main-style t-dop-style i-wid-50"
        style="height:114px;"
        :maxlength="
          $parent.$parent.getProgramCode() === 'lizing_ships' ? 1000 : null
        "
        v-model="$parent.project.UF_ANNOTATION"
        :disabled="$parent.$parent.projectDisabled"
        placeholder="Кратко опишите суть проекта: укажите цели реализации проекта, место проекта в стратегии развития организации заявителя, задачи и проблемы (в том числе отраслевые), на решение которых направлен проект;
          опишите возможное влияние проекта на развитие отрасли, на развитие смежных отраслей; укажите ключевые конкурентные преимущества и отличительные особенности продукта проекта, возможность импортозамещения;
          приведите описание применяемых при разработке продукта проекта технических решений, их новизны относительно мирового уровня. Укажите, какие научно-технические задачи уже решены, а какие планируется решить в ходе реализации проекта. Предельное число символов - 1000"
      ></textarea>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_ANNOTATION")
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_annotation"
};
</script>

<style scoped></style>
